import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { useSSRStorePrefill } from "../../../store/reducers";
import { usePageURL } from "../../../utils/urls";
import { RetailCards } from "../RetailCards";
import { prefillSSRRetailData } from "../ssr";

type IProps = Immutable<templates.RetailCardsBlockTemplate>;

export const RetailCardsSSR = (_props: IProps): React.JSX.Element => {
    useSSRStorePrefill({}, prefillSSRRetailData);

    const findARetailer = usePageURL("find_a_retailer");
    const homePage = usePageURL("home");

    return (
        <section>
            <RetailCards retailLocatorLink={findARetailer || homePage} />
        </section>
    );
};
